// src/hooks/useTrackChangesAutoEnable.ts
import * as React from "react";
import { enableTrackChanges } from "../helpers/word";

interface TrackChangesNotification {
  message: string;
  variant: "info" | "warning";
}

/**
 * Auto-enables Track Changes on mount and provides notification state.
 */
export function useTrackChangesAutoEnable() {
  const [notification, setNotification] = React.useState<TrackChangesNotification | null>(null);

  const dismissNotification = React.useCallback(() => setNotification(null), []);

  React.useEffect(() => {
    const initTrackChanges = async () => {
      const result = await enableTrackChanges();
      if (result.enabled) {
        setNotification({
          message:
            "Track Changes has been turned on to ensure all document edits are visible and auditable. You can turn it off anytime from the Review tab.",
          variant: "info",
        });
      } else if (result.unsupported || result.error) {
        setNotification({
          message:
            "We couldn't enable Track Changes automatically. To ensure edits are tracked, please enable it manually via the Review tab.",
          variant: "warning",
        });
      }
    };
    initTrackChanges();
  }, []);

  return { notification, dismissNotification };
}
